import {Component, OnInit, ViewChild} from '@angular/core';
import {AnnuityLetterService} from '../services/annuity-letter.service';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {MatDialog} from '@angular/material/dialog';
import { MatSort} from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {AnnuityValuesDialogComponent} from './dialogs/annuity-values-dialog/annuity-values-dialog.component';
import {AnnuityLetterDialogComponent} from './dialogs/annuity-letter-dialog/annuity-letter-dialog.component';
import {LetterAnnuity} from '../models/letter-annuity';
import {FormGroup} from '@angular/forms';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {EmailService} from '../services/email.service';

/*
interface MemberStatementStruct {
  name?: string | null;
  subCategory_name?: string | null;
  situation?: string | null;
  credit?: number | null;
  annuity_from?: number | null;
  url?: string | null;
  dateSent?: Date | null;
  datePayed?: Date | null;

}
*/

@Component({
  selector: 'app-annuity-letter',
  templateUrl: './annuity-letter.component.html',
  styleUrls: [ './annuity-letter.component.scss' ]
})
export class AnnuityLetterComponent implements OnInit {

  public lettersDataSource: MatTableDataSource<any>
  public displayedLettersColumns: string[] = [ 'name', 'edit' ];

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'name', 'situation', 'credit', 'annuity_from', 'sent', 'payed', 'goto', 'resend', 'delete', 'edit', 'selected' ];

  public letterArray: any[] = [];
  public lettersSent: any[] = [];

  public memberStatements: any[] = [];
  public selectedAnnuityLetter: any;

  public canSend: boolean = true;

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  // Opções de filtro
  filterOptions = [
    {id: 'all', label: 'Geral'},
    {id: 'sent', label: 'Enviados'},
    {id: 'payed', label: 'Pagos'}
  ];

  selectedFilter = 'all'; // Valor padrão
  textFilter = '';

  public memberStatementsFilter: any = []

  constructor (
    private _snackBar: SnackBarIconService,
    private _spinnerService: SpinnerService,
    private _annuityLetterService: AnnuityLetterService,
    private _dialog: MatDialog,
    private _emailService: EmailService
  ) { }

  ngOnInit () {
    this.loadLetters();
  }


  applyFilterOption (filterValue: string) {
    this.selectedFilter = filterValue;
    this.updateFilter();
  }

  updateFilter () {
    this.dataSource.filter = JSON.stringify({
      option: this.selectedFilter,
      text: this.textFilter
    });
  }

  applyFilter (filterValue: string) {
    this.textFilter = filterValue.trim().toLowerCase();
    this.updateFilter();
  }

  loadLetters () {
    this._annuityLetterService.loadAllAnnuityLetters() //CURRENT_ANNUITY_ID
      .subscribe((result) => {
        this.letterArray = []
        result.forEach((item) => {
          this.letterArray.push({
            "id": item.payload.doc.id,
            "annuity_id": item.payload.doc.data().annuity_id,
            "name": item.payload.doc.data().name,
            "subject": item.payload.doc.data().subject,
            "text": item.payload.doc.data().text,
            "image": item.payload.doc.data().image,
            "created": item.payload.doc.data().created,
            "deleted": item.payload.doc.data().deleted,
          })
        })
        this.lettersDataSource = new MatTableDataSource(this.letterArray);
      })

  }

  /*
  toggleCheckUsers (flag) {
    this.dataSource.data.forEach((item) => {
      item.selected = flag;
      if (!item.mustSend) {
        item.selected = false;
      }
    })
  }
*/

  openValuesDialog (element: any) {
    this._dialog.open(AnnuityValuesDialogComponent, {
      width: '600px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: element
    });
  }

  openLetterDialog (element: any) {

    let letter: any;
    if (element) {
      letter = element;
    } else {
      letter = new LetterAnnuity;
      letter.annuity_id = this.selectedAnnuityLetter.annuity_id;
      letter.created = new Date();
    }

    let dialogRef = this._dialog.open(AnnuityLetterDialogComponent, {
      width: '920px',
      height: '630px',
      panelClass: 'custom-dialog-container',
      data: letter
    });

    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: FormGroup = response[ 1 ];
        const image: FormGroup = response[ 2 ];
        const formData: any = form.getRawValue();

        const entity = this._annuityLetterService.createLetter(formData);
        // console.log("entity: " + JSON.stringify(entity));

        if (actionType == 'insert') {
          this._annuityLetterService.insert(entity)
            .then((result) => {
              if (image) {
                this._annuityLetterService.uploadImage(image, result.id)
              }
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch(() => {
              console.log("insert letter error")
            })
        } else if (actionType == 'update') {
          this._annuityLetterService.update(entity)
            .then(() => {
              // console.log(entity.id);
              if (image) {
                this._annuityLetterService.uploadImage(image, entity.id)
              }
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch(() => {
              console.log("update letter error")
            })
        }

      })

  }

  deleteLetter (element) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir esta carta?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._annuityLetterService.deleteLetter(element.id)
          .then(
            () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete regional error: ")}
          )
      }
    })
  }

  async selectAnnuityLetter (letter: any) {
    const waiting = this._spinnerService.show();

    await this.loadData();

    this.dataSource = null;

    this.selectedAnnuityLetter = letter;
    // console.log("letter: " + JSON.stringify(this.selectedAnnuityLetter))

    this.lettersSent = await this._annuityLetterService.loadAnnuityLettersSent(this.selectedAnnuityLetter.id);
    this.memberStatements.forEach((item) => {

      const exist = this.lettersSent.find((e) => {
        return e.member_id == item.id
      })
      if (exist) {
        item.selected = true;
        item.letter_sent = exist.id;
        item.dateSent = exist.dateSent ? exist.dateSent.toDate() : ""
        item.dateRead = exist.dateRead ? exist.dateRead.toDate() : ""
        item.datePayed = exist.datePayed ? exist.datePayed.toDate() : ""
        item.url = exist.url
        // console.log(JSON.stringify(item))
      }
    })

    this.dataSource = new MatTableDataSource(this.memberStatements); // memberPayedAnnuities
    this.dataSource.sort = this.sort;

    // Definindo o filtro personalizado
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      // O filtro agora será um objeto JSON stringificado contendo ambos os tipos de filtro
      const filters = JSON.parse(filter);

      // Aplica o filtro de opção
      let matchesOption = true;
      switch (filters.option) {
        case 'sent':
          matchesOption = !!data.dateSent && !data.datePayed;
          break;
        case 'payed':
          matchesOption = !!data.datePayed;
          break;
        case 'all':
        default:
          matchesOption = true;
      }

      // Aplica o filtro de texto (se houver)
      const matchesText = !filters.text ||
        Object.values(data).some(
          (value: any) => value &&
            value.toString().toLowerCase().includes(filters.text.toLowerCase())
        );

      return matchesOption && matchesText;
    };

    waiting.close();
  }

  reload () {
    // this.selectedAnnuityLetter
    this.selectAnnuityLetter(this.selectedAnnuityLetter);
    this.canSend = true;
  }

  async updateAnnuityLetters () {
    const waiting = this._spinnerService.show();

    const data = this.dataSource.data;

    //data.forEach(async (item: any) => {
    for (const item of data) {

      const letterSentExist = this.lettersSent.find((e) => {
        return e.member_id == item.id
      })

      if (!letterSentExist && item.selected) {

        let itemData = {...item};
        // itemData.name = this._annuityLetterService.crypto(itemData.name);
        // console.log("this.letter.email: " + itemData.email)
        itemData.email = this._annuityLetterService.crypto(itemData.email);
        // console.log("this.letter.email: " + itemData.email)

        // console.log("this.letter.email: " + itemData.cpf)
        itemData.cpf = this._annuityLetterService.crypto(itemData.cpf);
        // console.log("this.letter.email: " + itemData.cpf)

        itemData.cellPhone = this._annuityLetterService.crypto(itemData.cellPhone);
        itemData.address = this._annuityLetterService.crypto(itemData.address);
        itemData.number = this._annuityLetterService.crypto(itemData.number);
        itemData.complement = this._annuityLetterService.crypto(itemData.complement);
        itemData.district = this._annuityLetterService.crypto(itemData.district);
        itemData.city = this._annuityLetterService.crypto(itemData.city);
        itemData.state = this._annuityLetterService.crypto(itemData.state);
        itemData.country = this._annuityLetterService.crypto(itemData.country);
        itemData.postalCode = this._annuityLetterService.crypto(itemData.postalCode);

        itemData.foreignCustomer = itemData.foreignCustomer;
        itemData.tester = itemData.tester;

        itemData.letter_id = this.selectedAnnuityLetter.id;
        itemData.annuity_id = this.selectedAnnuityLetter.annuity_id;

        itemData.dateSent = new Date();
        itemData.url = this._annuityLetterService.makeUrl(itemData.id, this.selectedAnnuityLetter.annuity_id)

        // este dados não precisa no registro da carta enviada
        delete itemData.selected;
        delete itemData.situation;
        delete itemData.letter_sent;
        //
        // console.log("itemData: " + JSON.stringify(itemData));
        // console.log("this.selectedAnnuityLetter.annuity_id: " + JSON.stringify(this.selectedAnnuityLetter.annuity_id));
     
        const order: any = await this._annuityLetterService.createOrder(this.selectedAnnuityLetter.annuity_id, this.selectedAnnuityLetter.name, item)
        // console.log("new order: " + JSON.stringify(order))
        
        itemData.order_id = order.id
        
        await this._annuityLetterService.registerLetter(itemData)
          .then(() => {
            item.letterSent = item.id + ":" + this.selectedAnnuityLetter.annuity_id;
            item.letter_id = itemData.letter_id;
            item.dateSent = itemData.dateSent;
            item.url = itemData.url

            this.lettersSent.push(item)
            // console.log("lettersSent: " + JSON.stringify(this.lettersSent))
            this.sendEmail(item)

          })
          .catch((err) => {
            console.log("error register letter " + err.message)
          })
          
      }

    }

    waiting.close();
    this.canSend = false;

  }

  async loadData () {
    const waiting = this._spinnerService.show();

    let annuities = await this._annuityLetterService.loadAnnuities();
    // console.log("annuities " + JSON.stringify(annuities))
    let payedAnnuities = await this._annuityLetterService.getAnnuityOrders(annuities);
    // console.log("payedAnnuities " + JSON.stringify(payedAnnuities))
    let categories = await this._annuityLetterService.loadCategories();
    // console.log("categories " + JSON.stringify(categories))
    let members = await this._annuityLetterService.getMembersAnnuity(categories);
    // console.log("members " + JSON.stringify(members))
    this.memberStatements = await this._annuityLetterService.makeMemberStatement(members, annuities, payedAnnuities)

    annuities.length = 0;
    payedAnnuities.length = 0;
    categories.length = 0;
    members.length = 0;

    waiting.close();
  }

  sendEmail (data) {

    const image = "<img src='" + this.selectedAnnuityLetter.image + "'>";
    const url = data.url

    let emailBody = this.selectedAnnuityLetter.text;

    emailBody = emailBody.replace("[image]", image)
    emailBody = emailBody.replace("[member_name]", data.name)
    emailBody = emailBody.replace(/\[link:(.*?)\]/g, `<a href='${ url }'>$1</a>`);

    emailBody = "<div style='width: 600px;'>" + emailBody + "</div>";

    /*
    console.log("----------------------------");
    console.log("subject: " + this.selectedAnnuityLetter.subject)
    console.log("name: " + data.name);
    console.log("email: " + data.email);
    console.log("----------------------------");
    console.log("emailBody: " + emailBody);
    */

    this._emailService.sendStandardEmail({
      'subject': this.selectedAnnuityLetter.subject,
      'html': emailBody,
      'from': "SBCCV <cientifico@sbccv.org.br>",
      'to': data.email,
      'bcc': "cientifico@sbccv.org.br"
    })
      .then(() => {
        console.log("email enviado")
      })
      .catch(() => {
        console.log("send email error")
      })
  }

  deleteLetterSent (element: any) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir esta carta?"}
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result == "ok") {
        const waiting = this._spinnerService.show();

        this.canSend = false;

        const letter_sent_id = element.letter_sent
        const splits = letter_sent_id.split(":");
        const member_id = splits[ 0 ]
        const product_id = splits[ 1 ]

        console.log("delete letter_sent_id: " + letter_sent_id);
        await this._annuityLetterService.deleteLetterSent(letter_sent_id)
          .then(() => {
            element.dateSent = null;
            element.url = "";
            element.selected = false;
          })

        const order: any = await this._annuityLetterService.getOrdersPendingByMemberAndProductId(member_id, product_id)
        if (order) {
          const order_id = order[ 0 ].id
          console.log("delete order_id: " + order_id);
          await this._annuityLetterService.deleteOrder(order_id)
        }

        waiting.close();

      }
    })
  }

  openResendDialog (data: any) {
    // console.log("resend: " + JSON.stringify(data))
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: data.name + "<br><br>Reenviar esta carta?"}
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result == "ok") {

        this.canSend = false;

        console.log("data.letter_sent: " + data.letter_sent)
        await this._annuityLetterService.updateLetterSentDate(data.letter_sent)
          .then(() => {
            data.dateSent = new Date()
            console.log("send email again")
            this.sendEmail(data)
          })
          .catch((err) => {
            console.log("update error: " + err.message)
          })

      }
    })
  }


}
